import React from "react";
import Joi from "joi-browser";
import Form from "../comman/form";
import auth from "../services/authService";
import { Link } from "react-router-dom";

class Login extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: { username: "", password: "" },
      errors: {},
    };
  }

  schema = {
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
  };

  doSubmit = async () => {
    try {
      const { data } = this.state;
      await auth.login(data.username, data.password);
      //console.log(this.props);
      if (
        this.props.location !== undefined &&
        this.props.location.pathname !== "/login"
      ) {
        window.location = this.props.location.state.from.pathname;
      } else {
        window.location = "/";
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data.message;
        this.setState({ errors });
      }
    }
  };

  render() {
    if (auth.getCurrentUser()) return <Link to="/" />;
    return (
      <div style={{ backgroundColor: "#344032" }}>
        <div className="row col-md-12">
          <div className="col-xl-1 col-lg-2 col-md-2 pl-5 pt-2 pb-2">
            <image src="/assets/Img/truistLogo.png" height={70} />
          </div>
        </div>
        <div className="main-content">
          <div className="header bg-white pt-3">
            <div className="container">
              <div className="header-body text-center">
                <div className="row justify-content-center">
                  <div className="col-xl-12 col-lg-6 col-md-8">
                    <h1 style={{ color: "black" }}>
                      WORKFINITY*® NEXT GENERATION AUTOMATED GRANT MANAGEMENT
                      SYSTEM
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12" style={{ borderTop: "20px solid blue" }}>
              <p
                className="d-flex flex-column align-items-center pt-3"
                style={{ color: "black", fontWeight: 400 }}
              >
                GATEWAY ACCESS TO THE OREGON EDUCATOR NETWORK (OEN) AND PARTNER
                NETWORK
              </p>
            </div>
            <div className="row col-md-12 bg-gradient-secondary p-0 ml-0">
              <div
                className="col-xl-6"
                style={{
                  backgroundImage: "url(../../assets/img/image-workfinity.jpg)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
              ></div>
              <div className="col-xl-6">
                <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-7 p-2">
                    <div className="card mb-0">
                      <div className="card-body px-lg-5">
                        <div className="text-center mt--2 mb-3">
                          <h3>Welcome !</h3>
                          <p style={{ color: "black" }}>
                            Please enter your user credentials
                          </p>
                        </div>
                        <form onSubmit={this.handleSubmit}>
                          {this.renderInput("username", "Username")}
                          {this.renderInput("password", "Password", "password")}
                          <div className="row col-md-12">
                            <div className="col-md-6 custom-control custom-control-alternative custom-checkbox">
                              <input
                                className="custom-control-input"
                                id=" customCheckLogin"
                                type="checkbox"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor=" customCheckLogin"
                              >
                                <span className="text-black">Remember me</span>
                              </label>
                            </div>
                            <div className="col-md-6 text-right">
                              <a href="#">
                                <span
                                  className="text-black mr--4"
                                  style={{ fontSize: ".875rem" }}
                                >
                                  Forget Password
                                </span>
                              </a>
                            </div>
                          </div>
                          <div className="text-center">
                            {this.renderButton("Sign in")}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-12 text-center mt-5"
              style={{ borderTop: "20px solid blue" }}
            >
              <p
                className="text-black mt-2"
                style={{
                  fontSize: 12,
                  lineHeight: 1.5,
                  fontWeight: 400,
                  color: "black",
                }}
              >
                Under US Patent Protection
                <br></br>
                This software is licensed to the user. Use of the software
                constitutes acceptance of the terms and conditions of the
                License Agreement.
                <br></br>
                ©IPCS®, ©WorkFinity® All rights reserved.
                <br></br>
                <img src="../../assets/img/logo1.jpg" height={20} />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
